export const historyActionEnum = [
  { id: 'CREATED', label: 'vytvořena' },
  { id: 'UPDATED', label: 'změněna' },
  { id: 'DELETED', label: 'smazána' },
];


// WEBPACK FOOTER //
// ./src/modules/trips/_tripsEnums.ts